// extracted by mini-css-extract-plugin
export default {"shimmer":"Pagination_shimmer__glkdQ","dark_shimmer":"Pagination_dark_shimmer__KDLMo","pagination":"Pagination_pagination__k9iRw","active":"Pagination_active__bIuyq"};